<template>
  <Card>
    <template v-slot:title>Pré Visualização de Impressão</template>
    <template v-slot:content>
      <embed v-if="link" :src="link" width="100%" height="700px" />
    </template>
  </Card>
</template>

<script>
import qs from 'query-string';
import debounce from 'debounce';
import { baseURL } from '../../../services/api/baseApi';

export default {
  name: 'ReportTemplatePreview',
  props: {
    text: String,
    image1: String,
    image2: String,
  },
  data() {
    return {
      link: '',
    };
  },
  watch: {
    image1() {
      this.generateLink();
    },
    image2() {
      this.generateLink();
    },
    text() {
      this.generateLink();
    },
  },
  created() {
    this.generateLink();
  },
  methods: {
    generateLink: debounce(function generateLink() {
      const authorization = localStorage.getItem('Authorization');
      const query = {
        authorization,
        image1: this.image1,
        image2: this.image2,
        text: this.text,
      };
      this.link = `${baseURL}/reports/templates/preview?${qs.stringify(query)}`;
    }, 800),
  },
};
</script>

<style>
</style>